import axios from "axios";
import { errorMessage } from "./toastifyShowMessage";
import { HandleServicesError } from "./swalModal";

// ساختار دریافت و پست کردن دیتا
const QueryAPI = async (url = "", parameters = {}, type = "post") => {
  let response = null;

  try {
    const apiUrl = process.env.REACT_APP_API_KEY + url;
    if (type === "post") {
      response = await axios.post(apiUrl, parameters);
    } else {
      response = await axios.get(apiUrl);
    }
    if (response.data.HasError) {
      errorMessage(response.data.Message);
    }
  } catch (error) {
    console.error("An error occurred", error.code);
    HandleServicesError();
  }
  return response ? response.data : null;
};

export const useAPIPublic = () => {
  //دریافت توکن
  const createApiTokenBySession = async (parameters) => {
    let response = null;
    response = await QueryAPI("/public/Security/CreateAPITokenBySession", parameters);
    return response ? response?.Result : null;
  };
  //دریافت درصد مالیات
  const queryTaxPercent = async () => {
    let response = null;
    response = await QueryAPI("/public/BaseInfo/QueryTaxPercent", "", "GET");
    return response ? response.Result : null;
  };
  //دریافت توکن برای دسترسی به کیف پول
  const accessAsanWallet = async (request) => {
    let response = null;
    response = await QueryAPI("/public/Security/AccessAsanWallet", request);
    return response ? response?.Result : null;
  };
  //ارسال کد OTP
  const sendOTPCodeAsync = async (request) => {
    let response = null;
    response = await QueryAPI("/public/Security/SendOTPCodeAsync", request);
    return response ? response?.Result : null;
  };
  //ارسال مجدد کد OTP
  const resendOTPCode = async (request) => {
    let response = null;
    response = await QueryAPI("/public/Security/ResendOTPCode", request);
    return response ? response?.Result : null;
  };
  //تایید کد OTP
  const confirmOTPCode = async (request) => {
    let response = null;
    response = await QueryAPI("/public/Security/ConfirmOTPCode", request);
    return response ? response : null;
  };
  return {
    createApiTokenBySession,
    queryTaxPercent,
    accessAsanWallet,
    sendOTPCodeAsync,
    resendOTPCode,
    confirmOTPCode,
  };
};

export const useAPIDirectCharge = () => {
  //دریافت گروه های بسته
  const queryProductGroup = async () => {
    let response = null;
    response = await QueryAPI("/directCharging/Product/QueryProductGroup", response);
    return response ? response?.Result : null;
  };
  //دریافت بسته های پیشفرض
  const queryPackagesByPlanId = async (request) => {
    let response = null;
    response = await QueryAPI("/directCharging/Product/QueryPackagesByPlanId", request);
    return response ? response : null;
  };
  //دریافت بسته ها با دسته بندی
  const queryPackagesBySubGroup = async (request) => {
    let response = null;
    response = await QueryAPI("/directCharging/Product/QueryPackagesBySubGroup", request);
    return response ? response?.Result : null;
  };
  //نمایش لیست درگاه های پرداخت
  const queryGateWayByPlanId = async (request) => {
    let response = null;
    response = await QueryAPI("/directCharging/Payment/QueryGateWayByPlanId", request);
    return response ? response?.Result : null;
  };
  //نمایش بسته ها
  const queryPackage = async (request) => {
    let response = null;
    response = await QueryAPI("/directCharging/Product/QueryPackage", request);
    return response ? response?.Result : null;
  };
  //نمایش بسته های پرفروش
  const queryEPMostPurchased = async (request) => {
    let response = null;
    response = await QueryAPI("/directCharging/Product/QueryEPMostPurchased", request);
    return response ? response?.Result : null;
  };
  //نمایش بسته های ویژه
  const queryPromotionProducts = async (request) => {
    let response = null;
    response = await QueryAPI("/directCharging/Product/QueryPromotionProducts", request);
    return response ? response?.Result : null;
  };
  //نمایش بهترین بسته ها
  const queryBestSellingEPPackages = async (request) => {
    let response = null;
    response = await QueryAPI("/directCharging/Product/QueryBestSellingEPPackages", request);
    return response ? response?.Result : null;
  };
  //رفتن به درگاه بانک
  const redirectEPToIPGBankGateWay = async (request) => {
    let response = null;
    response = await QueryAPI("/directCharging/Payment/RedirectEPToIPGBankGateWay", request);
    return response ? response?.Result : null;
  };
  //رفتن به درگاه کیف پول آپ
  const redirectEPToAsanWallet = async (request) => {
    let response = null;
    response = await QueryAPI("/directCharging/Payment/RedirectEPToAsanWallet", request);
    return response ? response?.Result : null;
  };
  //دریافت اعتباری مشترک
  const queryBalance = async (request) => {
    let response = null;
    response = await QueryAPI("/directCharging/Subscription/QueryBalance?msisdn=" + request, "", "get");
    return response ? response?.Result : null;
  };
  //پرداخت با استفاده از اعتباری مشترک برای بسته
  const redirectEPToAccountBalanceGateWay = async (request) => {
    let response = null;
    response = await QueryAPI("/directCharging/Payment/RedirectEPToAccountBalanceGateWay", request);
    return response ? response?.Result : null;
  };
  //برگشت از بانک آسان پرداخت
  const callBackEPAsanPardakht = async (request) => {
    let response = null;
    response = await QueryAPI("/directCharging/Payment/CallBackEPAsanPardakht", request);
    return response ? response?.Result : null;
  };

  //برگشت از بانک پارسیان
  const callBackEPParsian = async (request) => {
    let response = null;
    response = await QueryAPI("/directCharging/Payment/CallBackEPParsian", request);
    return response ? response?.Result : null;
  };
  //بررسی اعتبار مشترک برای خرید بسته
  const isValidMSISDNToBuyPackage = async (request) => {
    let response = null;
    response = await QueryAPI("/directCharging/Subscription/IsValidMSISDNToBuyPackage", request);
    return response ? response?.Result : null;
  };
  //لیست شارژ
  const queryValidChargeByPlanId = async (request) => {
    let response = null;
    response = await QueryAPI("/directCharging/Product/QueryValidChargeByPlanId", request);
    return response ? response?.Result : null;
  };
  //بررسی شماره برای خرید شارژ
  const isValidMSISDNToBuyCharge = async (request) => {
    let response = null;
    response = await QueryAPI("/directCharging/Subscription/IsValidMSISDNToBuyCharge", request);
    return response ? response?.Result : null;
  };
  //رفتن به درگاه پرداخت شارژ
  const redirectDCToIPGBankGateWay = async (request) => {
    let response = null;
    response = await QueryAPI("/directCharging/Payment/RedirectDCToIPGBankGateWay", request);
    return response ? response?.Result : null;
  };

  //برگشت از بانک برای شارژ اسان پرداخت
  const callBackDCAsanPardakht = async (request) => {
    let response = null;
    response = await QueryAPI("/directCharging/Payment/CallBackDCAsanPardakht", request);
    return response ? response?.Result : null;
  };

  //برگشت از بانک پارسیان برای شارژ
  const callBackDCParsian = async (request) => {
    let response = null;
    response = await QueryAPI("/directCharging/Payment/CallBackDCParsian", request);
    return response ? response?.Result : null;
  };
  //رفتن به درگاه کیف پول آپ
  const redirectDCToAsanWallet = async (request) => {
    let response = null;
    response = await QueryAPI("/directCharging/Payment/RedirectDCToAsanWallet", request);
    return response ? response?.Result : null;
  };

  const callBackEPIPGMellatBank = async (request) => {
    let response = null;
    response = await QueryAPI("/directCharging/Payment/CallBackEPIPGMellatBank", request);
    return response ? response?.Result : null;
  };
  const callBackDCIPGMellatBank = async (request) => {
    let response = null;
    response = await QueryAPI("/directCharging/Payment/CallBackDCIPGMellatBank", request);
    return response ? response?.Result : null;
  };

  return {
    queryProductGroup,
    queryPackagesByPlanId,
    queryPackagesBySubGroup,
    queryGateWayByPlanId,
    queryPackage,
    queryEPMostPurchased,
    queryPromotionProducts,
    queryBestSellingEPPackages,
    redirectEPToIPGBankGateWay,
    redirectEPToAsanWallet,
    queryBalance,
    redirectEPToAccountBalanceGateWay,
    callBackEPAsanPardakht,
    callBackEPParsian,
    isValidMSISDNToBuyPackage,
    queryValidChargeByPlanId,
    isValidMSISDNToBuyCharge,
    redirectDCToIPGBankGateWay,
    callBackDCAsanPardakht,
    callBackDCParsian,
    redirectDCToAsanWallet,
    callBackEPIPGMellatBank,
    callBackDCIPGMellatBank,
  };
};
